export default __webpack_public_path__ + "static/media/627.35726feb.gif";